<template>
  <div v-if="ceroData" class="text-center my-5">
    <span class="h4">{{ $t("noDataToDisplay") }}</span>
  </div>
  <div v-else :class="{ container: !isReport }">
    <DoughnutChart v-if="loaded" :chartdata="chartdata" :options="options" />
  </div>
</template>

<script>
import DoughnutChart from "@/components/DoughnutChart";

export default {
  name: "DoughnutChartContainer",
  components: { DoughnutChart },
  data() {
    return {
      loaded: false,
      chartdata: null,
      options: null,
      ceroData: false,
    };
  },
  props: {
    isTotalPercentages: {
      type: Boolean,
      default: true,
    },
    showAmounts: {
      type: Boolean,
      default: true,
    },
    legendDisplay: {
      default: true,
    },
    padding: {
      default: 30,
    },
    showLabels: {
      default: true,
    },
    data: {
      default: null,
    },
    case: {
      default: null,
    },
    notAnswered: {
      default: true,
    },
    isReport: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getPercentage(data) {
      let total = 0;
      let dataPercent = [];

      for (let i = 0; i < data.length; i++) {
        total += data[i];
      }

      if (total) {
        for (let i = 0; i < data.length; i++) {
          let percent = (100 / total) * data[i];
          percent = this.hideDec(percent.toFixed(2));
          dataPercent.push(Math.round(percent));
        }
      } else {
        dataPercent = new Array(3).fill(0);
      }

      return dataPercent;
    },
    hideDec: num => {
      if (parseInt(num.split(".")[1]) == 0) {
        return num.split(".")[0];
      } else {
        return num;
      }
    },
  },
  async mounted() {
    this.loaded = false;
    let { secCol, primCol, blueCol, logoDarkCol } = this.$store.getters;
    let userList, data;

    if (!this.data) return;

    try {
      switch (this.case) {
        case "libros":
        case "desafios":
        case "obligatorio":
        case "gustoPropio":
          userList = {
            Correctas: this.data.totalRespuestasCorrectas,
            Incorrectas: this.data.totalRespuestasIncorrectas,
            "No contestadas": this.data.totalNoContestadas,
          };

          data = this.getPercentage(Object.values(userList));
          break;
        default:
          userList = {
            Correctas: this.data.porcentajeCorrectas,
            Incorrectas: this.data.porcentajeIncorrectas,
            "No contestadas": this.data.porcentajeNoContestadas,
          };

          data = [
            this.data.porcentajeCorrectas,
            this.data.porcentajeIncorrectas,
            this.data.porcentajeNoContestadas,
          ];
      }

      this.ceroData = data.every(value => value === 0);
      if (this.ceroData) return;

      let display = this.legendDisplay;
      let padding = this.padding;
      let showLabels = this.showLabels;
      let notAnswered = this.notAnswered;
      let backgroundColor = [secCol, primCol, blueCol];
      let labels = Object.keys(userList);

      if (!notAnswered) {
        labels.splice(2, 1);
        backgroundColor.splice(2, 1);
        data.splice(2, 1);
      }

      this.chartdata = {
        labels,
        datasets: [
          {
            label: "",
            backgroundColor,
            data,
            datalabels: {
              color: logoDarkCol,
              backgroundColor: "transparent",
              borderRadius: 50,
              align: "end",
              display: context => {
                const index = context.dataIndex;
                const value = context.dataset.data[index];
                return value != 0;
              },
              font: {
                size: 15,
                family: "Barlow Condensed",
              },
              padding,
              formatter: (value, context) => {
                let amount = "";
                let dataFormatted = `${value}%`;

                if (value <= 5) return dataFormatted;

                if (this.showAmounts) {
                  switch (context.dataIndex) {
                    case 0:
                      amount = this.isTotalPercentages
                        ? this.data.cantidadRespuestasCorrectas
                        : this.data.totalRespuestasCorrectas;
                      break;
                    case 1:
                      amount = this.isTotalPercentages
                        ? this.data.cantidadRespuestasIncorrectas
                        : this.data.totalRespuestasIncorrectas;
                      break;
                    case 2:
                      amount = this.isTotalPercentages
                        ? this.data.cantidadNoContestadas
                        : this.data.totalNoContestadas;
                      break;
                  }

                  dataFormatted = `${dataFormatted} (${amount})`;
                }

                if (showLabels)
                  dataFormatted = `${dataFormatted}\n${
                    context.chart.data.labels[context.dataIndex]
                  }`;

                return dataFormatted;
              },
            },
          },
        ],
      };

      this.options = {
        title: {
          display: true,
        },
        cutoutPercentage: 70,
        animation: {
          animateRotate: !this.isReport,
        },
        legend: {
          display,
          labels: {
            fontColor: "black",
            usePointStyle: true,
            padding: 20,
          },

          align: "start",
          // position: "right",
        },
        layout: {
          // padding: 50,
          padding: 60,
        },
      };
      this.loaded = true;
    } catch {
      // console.error(e);
    }
  },
};
</script>
